import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';

@Injectable()
export class CheckTokenInterceptor implements HttpInterceptor {

  constructor(private router: Router,
    private authService: AuthService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(tap(res => {
      if (res instanceof HttpResponse) {
        if (res && res.body && (res.body.statusid === 1 || res.body.statusid === 2 || res.body.statusid === 3)) {
          localStorage.clear();
          this.authService.loginStatusChanges()
          this.router.navigate(['auth', 'login', { statusId: res.body.statusid }]);
        }
      }
      return res;
    }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err && err.error && (err.error.statusid === 1 || err.error.statusid === 2 || err.error.statusid === 3)) {
            localStorage.clear();
            this.authService.loginStatusChanges()
            this.router.navigate(['auth', 'login', { statusId: err.error.statusid }]);
          }
        }
        return of(err);
      })
    );
  }
}
